import { Button } from "@blueprintjs/core";
import { ButtonContainer, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { BreedGridDto, BreedSearch, BreedForJudgeApi, BreedForJudgeSearch } from "../../../../../api";
import { CustomDataTable } from "../../../../../components";
import { useGlobalData } from "../../../../../contexts";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IPersonBreedJudgeSearchPanelProps {
  onBreedSelected: (breed: BreedGridDto) => void;
  personId: number;
}

export const PersonBreedJudgeSearchPanel: React.FunctionComponent<IPersonBreedJudgeSearchPanelProps> = ({
  personId,
  onBreedSelected,
}) => {
  const api = useApiService(BreedForJudgeApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
    sortKeys: { breedGroupFullName: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: BreedSearch) =>
      api.baseSearch(
        BreedForJudgeSearch.fromJS({
          ...sObj,
          personId: personId,
          languageId: currentLanguage.languageId,
        })
      ),
    [api, currentLanguage.languageId, personId]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: BreedGridDto) => (
          <ButtonContainer>
            <Button
              onClick={() => {
                onBreedSelected(row);
              }}
              text={t(ETLCodes.Select)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.BreedGroupLabel),
        fieldName: "breedGroupNumber",
        render: (row: BreedGridDto) => row.breedGroupFullName,
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
    ],
    [onBreedSelected, t]
  );

  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return <CustomDataTable tableState={tableState} loading={loading} columns={columns} />;
};
